import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { hrEmployerApi } from "@/lib/api/hr";
import { EmployeeDashboardView } from "@/components/hr/employee-dashboard-view";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Panel, QueryGate } from "@/components/shell/page";

export default function EmployerEmployeeDetailPage() {
  const { id } = useParams();
  const employeeId = Number(id);
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["hr", "employer", "employee-dashboard", employeeId],
    queryFn: () => hrEmployerApi.employeeDashboard(employeeId),
    enabled: Number.isFinite(employeeId),
  });
  const [pin, setPin] = useState("");
  const [status, setStatus] = useState("");

  return (
    <QueryGate loading={isLoading} error={error || !data ? "Could not load this employee." : null}>
      {data && (
        <div className="space-y-6">
          <Link
            to="/employer/employees"
            className="inline-flex min-h-11 cursor-pointer items-center text-sm font-medium text-primary hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            Back to employees
          </Link>
          <Panel title="Device PIN" description="Links this staff record to punches on the biometric devices.">
            <form
              className="flex flex-wrap items-end gap-3"
              onSubmit={async (event) => {
                event.preventDefault();
                await hrEmployerApi.linkPin(employeeId, pin);
                setStatus("PIN linked.");
                refetch();
              }}
            >
              <div className="space-y-1">
                <Label htmlFor="pin">PIN</Label>
                <Input id="pin" value={pin} onChange={(e) => setPin(e.target.value)} className="w-40" />
              </div>
              <Button type="submit">Save PIN</Button>
              {status && <p className="pb-2 text-sm text-emerald-800" role="status">{status}</p>}
            </form>
          </Panel>
          <EmployeeDashboardView data={data} employeePath="/employer" />
        </div>
      )}
    </QueryGate>
  );
}
